import Form from 'components/form/form.component';
import IncButton from 'components/inc-button/inc-button.component';
import { useFormContext } from 'react-hook-form';
import SpreedlyCheckoutSdkCvvForm from './cvv-form/spreedly-checkout-sdk-cvv-form.component';
import { Provider as SpreedlyCheckoutSdkFormProvider } from '../spreedly-checkout-sdk-form.context';
import { useTranslation } from 'react-i18next';
import { useSpreedlyCheckoutSdkForm } from '../spreedly-checkout-sdk-form.hooks';

const SpreedlyCheckoutSdkCvvRecacheForm = ({
  paymentInstrument,
  initOrderAttributes,
  onSuccess,
  onError,
  setLoading,
  isLoading,
}) => {
  const { t } = useTranslation();

  const value = useSpreedlyCheckoutSdkForm(
    initOrderAttributes,
    onSuccess,
    onError,
    paymentInstrument,
  );
  const { recache } = value;
  const { handleSubmit } = useFormContext();

  return (
    <Form>
      <SpreedlyCheckoutSdkFormProvider value={value}>
        <SpreedlyCheckoutSdkCvvForm />
      </SpreedlyCheckoutSdkFormProvider>
      <IncButton
        fullWidth
        onClick={handleSubmit(() => {
          setLoading(true);
          recache();
        })}
        disabled={isLoading}
        data-testid="CVVForm.IncButton"
      >
        {t('checkout.payment.spreedly.submit')}
      </IncButton>
    </Form>
  );
};

export default SpreedlyCheckoutSdkCvvRecacheForm;
